import React from 'react'
import AddLoan from '../components/AddLoan'

const LoanCalculate = () => {
  return (
    <div>
        <AddLoan/>
    </div>
  )
}

export default LoanCalculate